// ---------------------------------------------------------------------------
// Entra ID app roles (the `roles` claim on the ID token) and the groupings the
// UI gates on. Keep in sync with AppRoles.cs on the API side — the server is
// the enforcement point, these lists only drive navigation and affordances.
//
// Access matrix:
//   Administrator       read/write on Marketing operations and PDM
//   Marketing.ReadWrite read/write on Marketing operations, read-only on PDM
//   PDM.ReadWrite       read/write on PDM only
//   PDM.ReadOnly        read-only on PDM only
// ---------------------------------------------------------------------------

export const APP_ROLES = {
  administrator: 'Administrator',
  marketingReadWrite: 'Marketing.ReadWrite',
  pdmReadWrite: 'PDM.ReadWrite',
  pdmReadOnly: 'PDM.ReadOnly',
} as const;

export type AppRole = (typeof APP_ROLES)[keyof typeof APP_ROLES];

export const PDM_READ_ROLES: AppRole[] = [
  APP_ROLES.administrator,
  APP_ROLES.marketingReadWrite,
  APP_ROLES.pdmReadWrite,
  APP_ROLES.pdmReadOnly,
];

export const PDM_WRITE_ROLES: AppRole[] = [APP_ROLES.administrator, APP_ROLES.pdmReadWrite];

export const MARKETING_ROLES: AppRole[] = [
  APP_ROLES.administrator,
  APP_ROLES.marketingReadWrite,
];

export const ALL_APP_ROLES: AppRole[] = Object.values(APP_ROLES);
